<template>
    <div class="modal fade custom-modal" id="chooseModelModal" tabindex="-1" role="dialog" v-if="projectId"
         aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-keyboard="false">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content custom-modal-content" v-if="projectId">
                <div class="dismiss-modal-btn" @click="closeOpenedModal()">
                    <i class="fad fa-times-circle"></i>
                </div>

                <div class="modal-body developer-choose-modal custom-modal-body">
                    <div class="developer-choose-modal__header">
                        <h5 class="modal-title"> Alege din modelele existente </h5>
                        <a v-if="types.includes('apartment')"
                            :href="`/developer/${projectId}/add-project-step2?type=apartment`"
                            class="developer-choose-modal__button">
                            <i class="fad fa-plus"></i> Adaugă model apartament
                        </a>
                        <a v-if="types.includes('commercial')"
                            :href="`/developer/${projectId}/add-project-step2?type=commercial`"
                            class="developer-choose-modal__button">
                            <i class="fad fa-plus"></i> Adaugă model spatiu
                        </a>
                    </div>
                    <div class="pdetail-levels-container levels-container">
                        <div
                            class="developer-choose-modal__model"
                            v-for="(model, key) in models"
                            @click="selectModel(model)"
                            :key="key"
                        >
                            <div class="developer-choose-modal__model-name">
                                <span v-if="model.type != 'commercial'">{{ model.rooms_count ? model.rooms_count.name : '' }} tip {{ model.model_type }}</span>
                                <span v-if="model.type == 'commercial'">Spatiu comercial tip {{ model.model_type }}</span>
                            </div>
                            <div class="developer-choose-modal__model-surface">
                                <span v-if="model.useful_surface"> Suprafata {{ model.useful_surface }} m², </span>
                                <span v-if="model.terrace_surface"> Balcon {{ model.terrace_surface }} m² </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DeveloperChooseModelModal",
    data() {
        return {
            models: [],
            projectId: null,
            types: null,
        }
    },
    created() {
    },
    mounted() {
        let vm = this
        $('#chooseModelModal').on('hidden.bs.modal', function () {
            vm.projectId = null;
            vm.types = null;
            vm.models = [];
        });
        this.$eventBus.$on('OPEN_CHOOSE_MODEL_MODAL', async function (payLoad) {
            vm.projectId = payLoad.projectId;
            vm.types = payLoad.types.split('-');
            await vm.getModels();
            $('#chooseModelModal').modal('show');
        });
    },
    methods: {
        closeOpenedModal() {
            $('#chooseModelModal').modal('hide')
        },
        getModels() {
            let vm = this;
            window.axios.get(`/ajax/developer/get-models/${this.projectId}/${this.types.join('-')}`)
                .then(function (response) {
                    vm.models = response.data.data;
                })
                .catch(function () {
                    // console.log(err)
                    // window.showError(err)
                });
        },
        selectModel(model) {
            let vm = this;
            vm.$eventBus.$emit('MODEL_SELECTED', {
                model: model
            });
            $('#chooseModelModal').modal('hide');
        },
    }
}
</script>

<style scoped>
    .single-level-row {
        cursor: pointer;
    }
</style>